import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  ApiErrorResponse,
  ApiResponse,
  ENV,
  IEnvironment,
} from '@shabic/models';
import { MediaService } from './media.service';

@Injectable({
  providedIn: 'root',
})
export class OrderMediaService {
  constructor(
    private http: HttpClient,
    @Inject(ENV) private env: IEnvironment,
    private mediaService: MediaService
  ) {}

  /**
   * Upload images for order replacement/return following the same pattern as AddProductService
   * @param files Array of image files to upload
   * @returns Observable with media IDs from the upload response or error
   */
  uploadOrderImages(files: File[]): Observable<ApiResponse<number[] | ApiErrorResponse>> {
    if (files.length === 0) {
      return of(new ApiResponse([]));
    }

    // Use the correct media endpoint: /api (MediaService adds /media automatically)
    const mediaEndpoint = this.env.production 
      ? this.env.marketplaceApiUrl
      : '/api';

    console.log('Order Media Upload Endpoint:', mediaEndpoint);

    return this.mediaService.upload(mediaEndpoint, files, 'PRODUCT').pipe(
      map(response => {
        if (response.payload && Array.isArray(response.payload)) {
          // Extract media IDs from the response
          const mediaIds = response.payload.map((media: any) => media.id);
          console.log('Extracted media IDs from upload:', mediaIds);
          return new ApiResponse(mediaIds);
        }
        return new ApiResponse([]);
      }),
      catchError(error => {
        console.error('Order Media Upload Error:', error);
        return of(new ApiResponse(new ApiErrorResponse(error)));
      })
    );
  }
} 